import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { PropDtls } from '../shared/property-details';
import { MrkIns } from '../shared/market-insights';
import { ListDtls } from '../shared/listing-details';
import { environment } from '../../environments/environment';
import { constants } from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class PropertyDetailsService {

  constructor(private http: HttpClient) { }
  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Access-Token': environment.prospektr_sell_backend_access_token
    }),
  };

  GetPropertyDetails(streetAddress: string, city: string, state: string, zipCode: string): Observable<PropDtls> {
    let url = environment.prospektr_sell_backend_base_url + constants.get_property_details + '?State=' + state + '&PostalCode=' + zipCode + '&City=' + city + '&StreetAddress=' + streetAddress + '&OrderId=MATCHAPPEND';
    return this.http
      .get<PropDtls>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetListingDetails(streetAddress: string, city: string, state: string, zipCode: string, unitNumber: string): Observable<ListDtls> {
    let url = environment.prospektr_sell_backend_base_url + constants.get_listing_details + '?State=' + state + '&Zip=' + zipCode + '&City=' + city + '&Street=' + streetAddress + '&OrderId=MATCHAPPEND&IncludeImages=true';
    if (unitNumber != null && unitNumber != '') {
      url = url + '&UnitNumber=' + unitNumber;
    }
    return this.http
      .get<ListDtls>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetMarketInsightsByPostalCode(zipCode: string): Observable<MrkIns> {
    let url = environment.prospektr_sell_backend_base_url + constants.get_market_insights + '?drillDownBy=PropertyType&postalCode=' + zipCode + '&type=property&numberOfMonths=1';
    return this.http
      .get<MrkIns>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetPropertyData(streetAddress: string, city: string, state: string, zipCode: string, unitNumber: string): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.get_property_data + '?State=' + state + '&PostalCode=' + zipCode + '&City=' + city + '&StreetAddress=' + streetAddress + '&OrderId=MATCHAPPEND&IncludeImages=true';
    if (unitNumber != null && unitNumber != '') {
      url = url + '&UnitNumber=' + unitNumber;
    } return this.http
      .get<any>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  // Error handling
  errorHandl(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
